module.exports = __webpack_public_path__ + "img/Logos-Footer-PhotoVision.a12096be.png";